<template>
  <div>
    <div class="totalPie">
      <div class="tit">
        <p>雨区淤地坝统计</p>
        <el-switch class="elSwitch" style="display: block" v-model="value" active-color="#13ce66" inactive-color="#409eff" active-text="饼图" inactive-text="柱图" @change="switchChange">
        </el-switch>
      </div>
      <div class="contents boderBottom">
        <p></p>
        <p class="title1">淤地坝数量统计
          <el-button size="mini" round @click="bigdialogClick('ybydbNum')">大图</el-button>
        </p>
        <div class="Piebar">
          <span v-if="numAll!=0" style="margin-top: 30px;">总和：{{numAll}}</span>
          <div class="Piebar" id="numbar"></div>
        </div>
      </div>
      <div class="contents boderBottom">
        <p></p>
        <p class="title1">影响人数统计
          <el-button size="mini" round @click="bigdialogClick('ybyxrs')">大图</el-button>
        </p>
        <div class="Piebar">
          <span v-if="yxrsAll!=0">总和：{{yxrsAll}}</span>
          <div class="Piebar" id="yxrsbar"></div>
        </div>
      </div>
      <div class="contents boderBottom">
        <p></p>
        <p class="title1">重要设施统计
          <el-button size="mini" round @click="bigdialogClick('ybzyss')">大图</el-button>
        </p>
        <div class="Piebar">
          <span v-if="zyssAll!=0">总和：{{zyssAll}}</span>
          <div class="Piebar" id="zyssbar"></div>
        </div>
      </div>
      <div class="contents">
        <p></p>
        <p class="title1">不同降雨量影响淤地坝统计
          <el-button size="mini" round @click="bigdialogClick('ybjytj')">大图</el-button>
        </p>
        <div class="Piebar" id="jytjbar"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  //5.21
  selectCount,
  selectCountB,
  selectYXRSSum,
  selectYXRSSumB,
  selectZYSSSum,
  selectZYSSSumB,
  selectJYLSum
} from "@/api/api.js";
export default {
  // props: ['nowState'],
  data() {
    return {
      show: false,

      numBar: null,
      yxrsBar: null,
      zyssBar: null,
      jytjBar: null,

      numAll: 0,//淤地坝数量统计总和
      yxrsAll: 0,//影响人数统计总和
      zyssAll: 0,//重要设施统计总和

      xzqhCityName: [],
      xzqhCityId: [],
      xzqhDxbNum: [],
      xzqhZxbNum: [],
      xzqhDxbYrNum: [],
      xzqhZxbYrNum: [],

      yxrsCityName: [],
      yxrsCityId: [],
      dxyrYdb: [],
      zxyrYdb: [],

      zyssCityName: [],
      zyssCityId: [],
      dxZyssYdb: [],
      zxZyssYdb: [],

      jytjCityName: [],
      jytjCityId: [],
      a10Sum: [],
      a25Sum: [],
      a50Sum: [],
      a100Sum: [],
      a250Sum: [],
      a255Sum: [],

      ydbCodeLists: null,

      //饼柱切换
      value: false,
    };
  },
  mounted() {
    let params = {
      regionCode: this.$store.state.nowxingzhengCode,
      yuShi: this.$store.state.yuShi
    };
    //获取淤地坝数量统计
    this.ydbtotalForRegionNew(params);
    //获取淤地坝数量统计按影响人数
    this.ydbtotalForYxrsNew(params);
    //获取淤地坝数量统计按重要设施
    this.ydbtotalForZyssNew(params);
    //获取淤地坝数量统计按降雨量
    this.ydbtotalForjyl(params);
  },
  computed: {
    nowxingzhengCodes() {
      return this.$store.state.nowxingzhengCode; //需要监听的数据
    },
    myydbDataFuns() {
      return this.$store.state.myydbData; //需要监听的数据
    },
    yuShiFuns() {
      return this.$store.state.yuShi; //需要监听的数据
    },
  },
  watch: {
    nowxingzhengCodes(newVal, oldVal) {
      // if (oldVal) {
      let params;
      if (this.$store.state.ydbryorssShow == false) {
        params = {
          regionCode: newVal,
          yuShi: this.$store.state.yuShi
        };
      } else {
        params = {
          regionCode: newVal,
          ydbCodeList: this.$store.state.myydbData,
          yuShi: this.$store.state.yuShi
        };
      }
      //获取淤地坝数量统计按降雨量
      this.ydbtotalForjyl(params);
      if (this.value == false) {
        //获取淤地坝数量统计
        this.ydbtotalForRegionNew(params);
        //获取淤地坝数量统计按影响人数
        this.ydbtotalForYxrsNew(params);
        //获取淤地坝数量统计按重要设施
        this.ydbtotalForZyssNew(params);
      } else {
        //获取淤地坝数量统计
        this.ydbtotalForRegion(params);
        //获取淤地坝数量统计按影响人数
        this.ydbtotalForYxrs(params);
        //获取淤地坝数量统计按重要设施
        this.ydbtotalForZyss(params);
      }
      // }
    },
    myydbDataFuns(newVal, oldVal) {
      if (oldVal != null) {
        let params;
        this.ydbCodeLists = newVal;
        if (this.$store.state.ydbryorssShow == false && this.$store.state.kxcxStatus == false && this.$store.state
          .dzmcxStatus == false && this.$store.state.dtjcxStatus == false) {
          params = {
            regionCode: this.$store.state.nowxingzhengCode,
            yuShi: this.$store.state.yuShi
          };
        } else {
          params = {
            regionCode: this.$store.state.nowxingzhengCode,
            ydbCodeList: newVal,
            yuShi: this.$store.state.yuShi
          };
        }

        //获取淤地坝数量统计按降雨量
        this.ydbtotalForjyl(params);
        if (this.value == false) {
          //获取淤地坝数量统计
          this.ydbtotalForRegionNew(params);
          //获取淤地坝数量统计按影响人数
          this.ydbtotalForYxrsNew(params);
          //获取淤地坝数量统计按重要设施
          this.ydbtotalForZyssNew(params);
        } else {
          //获取淤地坝数量统计
          this.ydbtotalForRegion(params);
          //获取淤地坝数量统计按影响人数
          this.ydbtotalForYxrs(params);
          //获取淤地坝数量统计按重要设施
          this.ydbtotalForZyss(params);
        }
      }
    },
    yuShiFuns(newVal, oldVal) {
      let params = {
        regionCode: this.$store.state.nowxingzhengCode,
        ydbCodeList: this.$store.state.myydbData,
        yuShi: newVal
      };
      //获取淤地坝数量统计按降雨量
      this.ydbtotalForjyl(params);
      if (this.value == false) {
        //获取淤地坝数量统计
        this.ydbtotalForRegionNew(params);
        //获取淤地坝数量统计按影响人数
        this.ydbtotalForYxrsNew(params);
        //获取淤地坝数量统计按重要设施
        this.ydbtotalForZyssNew(params);
      } else {
        //获取淤地坝数量统计
        this.ydbtotalForRegion(params);
        //获取淤地坝数量统计按影响人数
        this.ydbtotalForYxrs(params);
        //获取淤地坝数量统计按重要设施
        this.ydbtotalForZyss(params);
      }
    },
  },
  methods: {
    //饼柱图切换
    switchChange(value) {
      // console.log(value)
      this.numAll = 0;
      this.yxrsAll = 0;
      this.zyssAll = 0;
      this.$emit("bzswitch", value);
      let params = {
        regionCode: this.$store.state.nowxingzhengCode,
        ydbCodeList: this.$store.state.myydbData,
        yuShi: this.$store.state.yuShi
      };
      //获取淤地坝数量统计按降雨量
      // this.ydbtotalForjyl(params);
      if (value == false) {//饼图
        //获取淤地坝数量统计
        this.ydbtotalForRegionNew(params);
        //获取淤地坝数量统计按影响人数
        this.ydbtotalForYxrsNew(params);
        //获取淤地坝数量统计按重要设施
        this.ydbtotalForZyssNew(params);
      } else {//柱图
        //获取淤地坝数量统计
        this.ydbtotalForRegion(params);
        //获取淤地坝数量统计按影响人数
        this.ydbtotalForYxrs(params);
        //获取淤地坝数量统计按重要设施
        this.ydbtotalForZyss(params);
      }
    },

    //大图点击事件
    bigdialogClick(type) {
      let echartsData = {};
      echartsData.type = type;
      echartsData.isBar = this.value;
      if (type == 'ybydbNum') {
        echartsData.title = '淤地坝数量统计';
        echartsData.xzqhCityName = this.xzqhCityName;
        echartsData.xzqhCityId = this.xzqhCityId;
        echartsData.xzqhDxbNum = this.xzqhDxbNum;
        echartsData.xzqhZxbNum = this.xzqhZxbNum;
        echartsData.xzqhDxbYrNum = this.xzqhDxbYrNum;
        echartsData.xzqhZxbYrNum = this.xzqhZxbYrNum;
      } else if (type == 'ybyxrs') {
        echartsData.title = '影响人数统计';
        echartsData.yxrsCityName = this.yxrsCityName;
        echartsData.yxrsCityId = this.yxrsCityId;
        echartsData.dxyrYdb = this.dxyrYdb;
        echartsData.zxyrYdb = this.zxyrYdb;
      } else if (type == 'ybzyss') {
        echartsData.title = '重要设施统计';
        echartsData.zyssCityName = this.zyssCityName;
        echartsData.zyssCityId = this.zyssCityId;
        echartsData.dxZyssYdb = this.dxZyssYdb;
        echartsData.zxZyssYdb = this.zxZyssYdb;
      } else if (type == 'ybjytj') {
        echartsData.title = '不同降雨量影响淤地坝统计';
        echartsData.jytjCityName = this.jytjCityName;
        echartsData.jytjCityId = this.jytjCityId;
        echartsData.a10Sum = this.a10Sum;
        echartsData.a25Sum = this.a25Sum;
        echartsData.a50Sum = this.a50Sum;
        echartsData.a100Sum = this.a100Sum;
        echartsData.a250Sum = this.a250Sum;
        echartsData.a255Sum = this.a255Sum;
      }
      this.$emit("bigDialogData", echartsData);
    },

    //获取淤地坝数量统计柱图
    ydbtotalForRegion(params) {
      this.xzqhCityName = [];
      this.xzqhCityId = [];
      this.xzqhDxbNum = [];
      this.xzqhZxbNum = [];
      this.xzqhDxbYrNum = [];
      this.xzqhZxbYrNum = [];
      selectCount(params).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          this.xzqhCityName.push(res.data[i].addressName);
          this.xzqhCityId.push({
            code: res.data[i].addressCode,
            name: res.data[i].addressName
          });
          this.xzqhDxbNum.push(res.data[i].dxYdbSum);
          this.xzqhZxbNum.push(res.data[i].zxYdbSum);
          this.xzqhDxbYrNum.push(res.data[i].dxxyyr);
          this.xzqhZxbYrNum.push(res.data[i].zxxyyr);
        }
        this.xzqbar(this.xzqhCityId, this.xzqhCityName, this.xzqhDxbNum, this.xzqhZxbNum, this.xzqhDxbYrNum, this.xzqhZxbYrNum);
      });
    },

    //获取淤地坝数量统计饼图
    ydbtotalForRegionNew(params) {
      this.xzqhCityName = '全部地区';
      this.xzqhDxbNum = 0;
      this.xzqhZxbNum = 0;
      this.xzqhDxbYrNum = 0;
      this.xzqhZxbYrNum = 0;

      selectCountB(params).then((res) => {
        this.xzqhDxbNum = res.data[0].dxYdbSum;
        this.xzqhZxbNum = res.data[0].zxYdbSum;
        this.xzqhDxbYrNum = res.data[0].dxxyyr;
        this.xzqhZxbYrNum = res.data[0].zxxyyr;
        this.xzqbarNew(this.xzqhCityName, this.xzqhDxbNum, this.xzqhZxbNum, this.xzqhDxbYrNum, this.xzqhZxbYrNum);
      });
    },

    //影响人数统计柱图
    ydbtotalForYxrs(params) {
      this.yxrsCityName = [];
      this.yxrsCityId = [];
      this.dxyrYdb = [];
      this.zxyrYdb = [];
      selectYXRSSum(params).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          this.yxrsCityName.push(res.data[i].addressName);
          this.yxrsCityId.push({
            code: res.data[i].addressCode,
            name: res.data[i].addressName
          });
          this.dxyrYdb.push(res.data[i].dxyxrs);
          this.zxyrYdb.push(res.data[i].zxyxrs);
        }
        this.yxrsbar(this.yxrsCityId, this.yxrsCityName, this.dxyrYdb, this.zxyrYdb);
      });
    },

    //影响人数统计饼图
    ydbtotalForYxrsNew(params) {
      this.yxrsCityName = '全部地区';
      this.dxyrYdb = 0;
      this.zxyrYdb = 0;
      selectYXRSSumB(params).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].ydbbx == '大型') {
            this.dxyrYdb = res.data[i].yxrsSum;
          } else if (res.data[i].ydbbx == '中型') {
            this.zxyrYdb = res.data[i].yxrsSum;
          }
        }
        this.yxrsbarNew(this.yxrsCityName, this.dxyrYdb, this.zxyrYdb);
      });
    },

    //获取淤地坝数量统计按重要设施柱图
    ydbtotalForZyss(params) {
      this.zyssCityName = [];
      this.zyssCityId = [];
      this.dxZyssYdb = [];
      this.zxZyssYdb = [];
      selectZYSSSum(params).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          this.zyssCityName.push(res.data[i].addressName);
          this.zyssCityId.push({
            code: res.data[i].addressCode,
            name: res.data[i].addressName
          });
          this.dxZyssYdb.push(res.data[i].dxzyssSum);
          this.zxZyssYdb.push(res.data[i].zxzyssSum);
        }
        this.zyssbar(this.zyssCityId, this.zyssCityName, this.dxZyssYdb, this.zxZyssYdb);
      });
    },

    //获取淤地坝数量统计按重要设施饼图
    ydbtotalForZyssNew(params) {
      this.zyssCityName = '全部地区';
      this.dxZyssYdb = 0;
      this.zxZyssYdb = 0;
      selectZYSSSumB(params).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].ydbbx == '大型') {
            this.dxZyssYdb = res.data[i].zyssSum;
          } else if (res.data[i].ydbbx == '中型') {
            this.zxZyssYdb = res.data[i].zyssSum;
          }
        }
        this.zyssbarNew(this.zyssCityName, this.dxZyssYdb, this.zxZyssYdb);
      });
    },

    //获取淤地坝数量统计按降雨量柱图
    ydbtotalForjyl(params) {
      this.jytjCityName = [],
        this.jytjCityId = [],
        this.a10Sum = [],
        this.a25Sum = [],
        this.a50Sum = [],
        this.a100Sum = [],
        this.a250Sum = [],
        this.a255Sum = [],

        selectJYLSum(params).then((res) => {
          // console.log(res)
          for (let i = 0; i < res.data.length; i++) {
            this.jytjCityName.push(res.data[i].addressName);
            this.jytjCityId.push({
              code: res.data[i].addressCode,
              name: res.data[i].addressName
            });
            this.a10Sum.push(res.data[i].a10Sum);
            this.a25Sum.push(res.data[i].a25Sum);
            this.a50Sum.push(res.data[i].a50Sum);
            this.a100Sum.push(res.data[i].a100Sum);
            this.a250Sum.push(res.data[i].a250Sum);
            this.a255Sum.push(res.data[i].a255Sum);
          }
          this.jytjbar(this.jytjCityId, this.jytjCityName, this.a10Sum, this.a25Sum, this.a50Sum, this.a100Sum,
            this.a250Sum, this.a255Sum);
        });
    },

    //淤地坝数量统计柱图
    xzqbar(xzqhCityId, xzqhCityName, xzqhDxbNum, xzqhZxbNum, xzqhDxbYrNum, xzqhZxbYrNum) {
      let _this = this;
      this.numBar = this.$echarts.init(document.getElementById("numbar"));

      this.numBar.on('click', function (value) {
        let currentObject = [];
        for (let i = 0; i < xzqhCityId.length; i++) {
          if (value.name == xzqhCityId[i].name) {
            currentObject.push({
              code: xzqhCityId[i].code,
              sectionName: value.seriesName
            });
          }
        }
        _this.$emit("ClickNames", currentObject);
        _this.$emit("DialogVisibles", true);
        _this.$emit("cxDialogVisibles", false);
      });

      let option = {
        title: {
          show: false,
          text: "",
          textStyle: {
            fontSize: 25,
            fontWeight: "normal",
            color: "#fff",
          },
          x: "center",
        },

        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "10%",
          top: "20%",
          containLabel: true,
        },
        legend: {
          data: ["大型坝", "中型坝", '大型有人坝', '中型有人坝'],
          /*right: 10,*/
          // top: "4%",
          textStyle: {
            color: "#fff",
            fontSize: 12
          },
          itemWidth: 12,
          itemHeight: 10,
          // itemGap: 35
        },
        dataZoom: [{
          type: "slider", //slider表示有滑动块的，
          show: true,
          zoomLock: false,
          left: 'center',
          bottom: '3%',
          height: '15',
          xAxisIndex: [0], //表示x轴折叠
          start: 1, //数据窗口范围的起始百分比,表示1%
          end: 50, //数据窗口范围的结束百分比,表示35%坐标
          textStyle: {
            color: "#ccc",
            // fontWeight: "bold",
            fontSize: 12,
          },
        },],
        xAxis: {
          type: "category",
          data: xzqhCityName,
          axisLine: {
            lineStyle: {
              color: "#ccc",
            },
          },
          axisLabel: {
            // interval: 0,
            // rotate: 40,
            textStyle: {
              fontFamily: "Microsoft YaHei",
              fontSize: 14
            },
          },
        },

        yAxis: {
          name: "数量",
          type: "value",
          // max: "150",
          axisLine: {
            show: false,
            lineStyle: {
              color: "#ccc",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(255,255,255,0.3)",
            },
          },
          axisLabel: {},
        },

        series: [{
          name: "大型坝",
          type: "bar",
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#FFE557",
              },
              {
                offset: 1,
                color: "#FFE557",
              },
              ]),
            },
          },
          data: xzqhDxbNum,
        },
        {
          name: "中型坝",
          type: "bar",
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#1CEA58",
              },
              {
                offset: 1,
                color: "#1CEA58",
              },
              ]),
            },
          },
          data: xzqhZxbNum,
        },
        {
          name: "大型有人坝",
          type: "bar",
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#00B3FE",
              },
              {
                offset: 1,
                color: "#00B3FE",
              },
              ]),
            },
          },
          data: xzqhDxbYrNum,
        },
        {
          name: "中型有人坝",
          type: "bar",
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#B32EFF",
              },
              {
                offset: 1,
                color: "#B32EFF",
              },
              ]),
            },
          },
          data: xzqhZxbYrNum,
        },
        ],
      };
      this.numBar.clear();
      this.numBar.setOption(option);
    },

    //淤地坝数量统计饼图
    xzqbarNew(xzqhCityName, xzqhDxbNum, xzqhZxbNum, xzqhDxbYrNum, xzqhZxbYrNum) {
      let _this = this;
      this.numBar = this.$echarts.init(document.getElementById("numbar"));
      this.numAll = Number(xzqhDxbNum) + Number(xzqhZxbNum);

      // 点击图标
      this.numBar.on('click', function (value) {
        let bx, sfyr;
        if (value.name == '大型坝') {
          bx = '大型';
        } else if (value.name == '中型坝') {
          bx = '中型';
        } else if (value.name == '大型有人坝') {
          bx = '大型';
          sfyr = 1;
        } else {
          bx = '中型';
          sfyr = 1;
        }
        let currentObject = [];
        currentObject.push({
          regionCode: _this.$store.state.nowxingzhengCode,
          yuShi: _this.$store.state.yuShi,
          sfyr: sfyr,
          bx: bx
        });
        _this.$emit("ClickNames", currentObject);
      });
      let option = {
        legend: {
          left: 'center',
          top: 5,
          data: [{ name: "大型坝" }, { name: "中型坝" }, { name: "大型有人坝" }, { name: "中型有人坝" }],
          textStyle: {
            color: '#fff'
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: xzqhCityName + ' <br/>{b}: {c} '
        },
        series: [
          {
            type: 'pie',
            radius: [0, '70%'],
            label: {
              position: 'inner',
              fontSize: 14,
              formatter: '{c}'
            },
            startAngle: 270,
            labelLine: {
              show: false
            },
            data: [
              { value: xzqhDxbNum, name: "大型坝", itemStyle: { color: '#FFE557' } },
              { value: xzqhZxbNum, name: "中型坝", itemStyle: { color: '#1CEA58' } },
              { value: xzqhDxbYrNum, name: "大型有人坝", itemStyle: { color: '#00B3FE' } },
              { value: xzqhZxbYrNum, name: "中型有人坝", itemStyle: { color: '#B32EFF' } },
            ]
          },
        ]
      };
      this.numBar.clear();
      this.numBar.setOption(option);
    },

    //影响人数统计柱图
    yxrsbar(yxrsCityId, yxrsCityName, dxyrYdb, zxyrYdb) {
      let _this = this;
      this.yxrsBar = this.$echarts.init(document.getElementById("yxrsbar"));

      this.yxrsBar.on('click', function (value) {
        // console.log(value)
        let currentObject = [];
        for (let i = 0; i < yxrsCityId.length; i++) {
          if (value.name == yxrsCityId[i].name) {
            currentObject.push({
              code: yxrsCityId[i].code,
              sectionName: value.seriesName
            });
          }
        }
        _this.$emit("ClickNames", currentObject);
        _this.$emit("DialogVisibles", true);
        _this.$emit("cxDialogVisibles", false);
      });

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '4%',
          bottom: '10%',
          top: '20%',
          containLabel: true
        },
        legend: {
          data: ['大型坝', '中型坝'],
          // right: 'center',
          top: 0,
          textStyle: {
            color: "#fff"
          },
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 10
        },
        xAxis: {
          type: 'category',
          data: yxrsCityName,
          axisLine: {
            lineStyle: {
              color: 'white'
            }
          },
          axisLabel: {
            textStyle: {
              fontFamily: 'Microsoft YaHei'
            }
          },
        },
        yAxis: {
          name: "数量",
          type: 'value',
          // max: '1200',
          axisLine: {
            show: false,
            lineStyle: {
              color: '#ccc'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {}
        },
        dataZoom: [{
          type: "slider", //slider表示有滑动块的，
          show: true,
          zoomLock: false,
          left: 'center',
          bottom: '3%',
          height: '15',
          xAxisIndex: [0], //表示x轴折叠
          start: 1, //数据窗口范围的起始百分比,表示1%
          end: 20, //数据窗口范围的结束百分比,表示35%坐标
          textStyle: {
            color: "#ccc",
            // fontWeight: "bold",
            fontSize: 12,
          },
        }],
        series: [{
          name: '大型坝',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#FFE557 ",
              },
              {
                offset: 1,
                color: "#FFE557",
              },
              ]),
              // barBorderRadius: 5,
            },
          },
          data: dxyrYdb
        },
        {
          name: '中型坝',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#00B3FE",
              },
              {
                offset: 1,
                color: "#00B3FE",
              },
              ]),
              // barBorderRadius: 5,
            }
          },
          data: zxyrYdb
        },
        ]
      };
      this.yxrsBar.clear();
      this.yxrsBar.setOption(option);
    },

    //影响人数统计饼图
    yxrsbarNew(yxrsCityName, dxyrYdb, zxyrYdb) {
      let _this = this;
      this.yxrsBar = this.$echarts.init(document.getElementById("yxrsbar"));
      this.yxrsAll = Number(dxyrYdb) + Number(zxyrYdb);

      this.yxrsBar.on('click', function (value) {
        let bx;
        if (value.name == '大型坝') {
          bx = '大型';
        } else if (value.name == '中型坝') {
          bx = '中型';
        }
        let currentObject = [];
        currentObject.push({
          regionCode: _this.$store.state.nowxingzhengCode,
          yuShi: _this.$store.state.yuShi,
          sfyr: 1,
          bx: bx
        });
        _this.$emit("ClickNames", currentObject);
      });

      let option = {
        legend: {
          left: 'right',
          top: 5,
          data: [{ name: "大型坝" }, { name: "中型坝" }],
          textStyle: {
            color: '#fff'
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: yxrsCityName + ' <br/>{b}: {c} '
        },
        series: [
          {
            type: 'pie',
            radius: [0, '70%'],
            label: {
              position: 'inner',
              fontSize: 14,
              formatter: '{c}'
            },
            startAngle: 270,
            labelLine: {
              show: false
            },
            data: [
              { value: dxyrYdb, name: "大型坝", itemStyle: { color: '#FFE557' } },
              { value: zxyrYdb, name: "中型坝", itemStyle: { color: '#00B3FE' } },
            ]
          },

        ]
      };
      this.yxrsBar.clear();
      this.yxrsBar.setOption(option);
    },

    //重要设施统计柱图
    zyssbar(zyssCityId, zyssCityName, dxZyssYdb, zxZyssYdb) {
      let _this = this;
      this.zyssBar = this.$echarts.init(document.getElementById("zyssbar"));
      this.zyssBar.on('click', function (value) {
        // console.log(value)
        let currentObject = [];
        for (let i = 0; i < zyssCityId.length; i++) {
          if (value.name == zyssCityId[i].name) {
            currentObject.push({
              code: zyssCityId[i].code,
              sectionName: value.seriesName
            });
          }
        }
        _this.$emit("ClickNames", currentObject);
        _this.$emit("DialogVisibles", true);
        _this.$emit("cxDialogVisibles", false);
      });

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '4%',
          bottom: '10%',
          top: '20%',
          containLabel: true
        },
        legend: {
          data: ['大型坝', '中型坝'],
          // right: 'center',
          top: 0,
          textStyle: {
            color: "#fff"
          },
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 10
        },
        xAxis: {
          type: 'category',
          data: zyssCityName,
          axisLine: {
            lineStyle: {
              color: 'white'
            }
          },
          axisLabel: {
            textStyle: {
              fontFamily: 'Microsoft YaHei'
            }
          },
        },
        yAxis: {
          name: "数量",
          type: 'value',
          // max: '1200',
          axisLine: {
            show: false,
            lineStyle: {
              color: '#ccc'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {}
        },
        dataZoom: [{
          type: "slider", //slider表示有滑动块的，
          show: true,
          zoomLock: false,
          left: 'center',
          bottom: '3%',
          height: '15',
          xAxisIndex: [0], //表示x轴折叠
          start: 1, //数据窗口范围的起始百分比,表示1%
          end: 30, //数据窗口范围的结束百分比,表示35%坐标
          textStyle: {
            color: "#ccc",
            // fontWeight: "bold",
            fontSize: 12,
          },
        }],
        series: [{
          name: '大型坝',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#FFE557 ",
              },
              {
                offset: 1,
                color: "#FFE557",
              },
              ]),
              // barBorderRadius: 12,
            },
          },
          data: dxZyssYdb
        },
        {
          name: '中型坝',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#00B3FE",
              },
              {
                offset: 1,
                color: "#00B3FE",
              },
              ]),
              // barBorderRadius: 11,
            }
          },
          data: zxZyssYdb
        },
        ]
      };
      this.zyssBar.clear();
      this.zyssBar.setOption(option);
    },

    //重要设施统计饼图
    zyssbarNew(zyssCityName, dxZyssYdb, zxZyssYdb) {
      let _this = this;
      this.zyssBar = this.$echarts.init(document.getElementById("zyssbar"));
      this.zyssAll = Number(dxZyssYdb) + Number(zxZyssYdb);
      // 还有一个总计的
      this.zyssBar.on('click', function (value) {
        let bx;
        if (value.name == '大型坝') {
          bx = '大型';
        } else if (value.name == '中型坝') {
          bx = '中型';
        }
        let currentObject = [];
        currentObject.push({
          regionCode: _this.$store.state.nowxingzhengCode,
          yuShi: _this.$store.state.yuShi,
          zyss: 1,
          bx: bx
        });
        _this.$emit("ClickNames", currentObject);
      });

      let option = {
        legend: {
          left: 'right',
          top: 5,
          data: [{ name: "大型坝" }, { name: "中型坝" }],
          textStyle: {
            color: '#fff'
          },
        },
        tooltip: {
          trigger: 'item',
          formatter: zyssCityName + ' <br/>{b}: {c} '
        },
        series: [
          {
            type: 'pie',
            radius: [0, '70%'],
            label: {
              position: 'inner',
              fontSize: 14,
              formatter: '{c}'
            },
            startAngle: 270,
            labelLine: {
              show: false
            },
            data: [
              { value: dxZyssYdb, name: "大型坝", itemStyle: { color: '#FFE557' } },
              { value: zxZyssYdb, name: "中型坝", itemStyle: { color: '#00B3FE' } },
            ]
          },

        ]
      };
      this.zyssBar.clear();
      this.zyssBar.setOption(option);
    },

    //降雨统计统计柱图
    jytjbar(jytjCityId, jytjCityName, a10Sum, a25Sum, a50Sum, a100Sum, a250Sum, a255Sum) {
      let _this = this;
      this.jytjBar = this.$echarts.init(document.getElementById("jytjbar"));
      this.jytjBar.on('click', function (value) {
        // console.log(value)
        let currentObject = [];
        for (let i = 0; i < jytjCityId.length; i++) {
          if (value.name == jytjCityId[i].name) {
            currentObject.push({
              code: jytjCityId[i].code,
              sectionName: value.seriesName
            });
          }
        }
        _this.$emit("ClickNames", currentObject);
        _this.$emit("DialogVisibles", true);
        _this.$emit("cxDialogVisibles", false);
      });

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '4%',
          bottom: '10%',
          top: '20%',
          containLabel: true
        },
        legend: {
          data: ['10mm', '25mm', '50mm', '100mm', '250mm', '>250mm'],
          // right: 'center',
          top: 0,
          textStyle: {
            color: "#fff"
          },
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 10
        },
        xAxis: {
          type: 'category',
          data: jytjCityName,
          axisLine: {
            lineStyle: {
              color: 'white'
            }
          },
          axisLabel: {
            textStyle: {
              fontFamily: 'Microsoft YaHei'
            }
          },
        },
        yAxis: {
          name: "数量",
          type: 'value',
          // max: '1200',
          axisLine: {
            show: false,
            lineStyle: {
              color: '#ccc'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {}
        },
        dataZoom: [{
          type: "slider", //slider表示有滑动块的，
          show: true,
          zoomLock: false,
          left: 'center',
          bottom: '3%',
          height: '15',
          xAxisIndex: [0], //表示x轴折叠
          start: 1, //数据窗口范围的起始百分比,表示1%
          end: 30, //数据窗口范围的结束百分比,表示35%坐标
          textStyle: {
            color: "#ccc",
            // fontWeight: "bold",
            fontSize: 12,
          },
        }],
        series: [{
          name: '10mm',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#a5f38d ",
              },
              {
                offset: 1,
                color: "#a5f38d",
              },
              ]),
              // barBorderRadius: 12,
            },
          },
          data: a10Sum
        },
        {
          name: '25mm',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#39aa00",
              },
              {
                offset: 1,
                color: "#39aa00",
              },
              ]),
              // barBorderRadius: 11,
            }
          },
          data: a25Sum
        },
        {
          name: '50mm',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#63baff",
              },
              {
                offset: 1,
                color: "#63baff",
              },
              ]),
              // barBorderRadius: 11,
            }
          },
          data: a50Sum
        },
        {
          name: '100mm',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#0000fe",
              },
              {
                offset: 1,
                color: "#0000fe",
              },
              ]),
              // barBorderRadius: 11,
            }
          },
          data: a100Sum
        },
        {
          name: '250mm',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#ff00fe",
              },
              {
                offset: 1,
                color: "#ff00fe",
              },
              ]),
              // barBorderRadius: 11,
            }
          },
          data: a250Sum
        },
        {
          name: '>250mm',
          type: 'bar',
          barWidth: "8px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: "#720000",
              },
              {
                offset: 1,
                color: "#720000",
              },
              ]),
              // barBorderRadius: 11,
            }
          },
          data: a255Sum
        },
        ]
      };
      this.jytjBar.clear();
      this.jytjBar.setOption(option);
    },

    Cancel() {
      this.DialogVisible = false;
    },
  },
};
</script>

<style scoped>
.totalPie {
  /* width: 100%; */
  width: calc(100% + 4px);
  height: 1100px;
  background: url(../../common/images/dbg.png) no-repeat center;
  background-size: 100% 100%;
}

.contents {
  width: 96%;
  height: 23.5%;
  margin-left: 2%;
  margin-top: 1%;
}

.contents p:nth-child(1) {
  float: left;
  width: 6px;
  height: 6px;
  margin: 12px 5px 12px 10px;
  background-color: #00b3fe;
}

.boderBottom {
  border-bottom: 1px dotted #ccc;
}

.title1 {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  color: #00b3fe;
}

.Piebar {
  width: 100%;
  height: 220px;
}

.Piebar > span {
  float: left;
  margin-top: 5px;
  margin-left: 10px;
  color: #fff;
  font-size: 14px;
}

>>> .el-switch__label {
  color: #fff;
  height: 30px;
  line-height: 30px;
  margin: 5px;
}

>>> .el-switch__label.is-active {
  color: #409eff;
}

>>> .el-button--mini,
.el-button--mini.is-round {
  padding: 3px 10px;
  background: transparent;
  color: #fff;
  border: 1px solid #409eff;
}

>>> .tit span {
  margin-top: 3px;
}
</style>
